/**
 * @generated SignedSource<<bca4a2be0f1eedf430639fd24c62663b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RainchecksModalQuery$variables = {
  redeemableAtFacilityId?: string | null | undefined;
};
export type RainchecksModalQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly rainchecks?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly squareGiftCard: {
                readonly balance: number;
                readonly id: string;
              };
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"RainchecksList_customer">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type RainchecksModalQuery = {
  response: RainchecksModalQuery$data;
  variables: RainchecksModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redeemableAtFacilityId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "redeemableAtFacilityId",
  "variableName": "redeemableAtFacilityId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RaincheckConnection",
  "kind": "LinkedField",
  "name": "rainchecks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RaincheckEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Raincheck",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareGiftCard",
              "kind": "LinkedField",
              "name": "squareGiftCard",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RaincheckEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Raincheck",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expirationDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facility",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RaincheckConfiguration",
                "kind": "LinkedField",
                "name": "raincheckConfiguration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "limitRedemptionToFacility",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareGiftCard",
            "kind": "LinkedField",
            "name": "squareGiftCard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "squareId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RainchecksModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": [
                          (v1/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "RainchecksList_customer"
                      },
                      (v4/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RainchecksModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "availableRainchecks",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "expired",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "giftCardIsActive",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "hasNonZeroBalance",
                            "value": true
                          },
                          (v1/*: any*/)
                        ],
                        "concreteType": "RaincheckConnection",
                        "kind": "LinkedField",
                        "name": "rainchecks",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "usedRainchecks",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "hasNonZeroBalance",
                            "value": false
                          }
                        ],
                        "concreteType": "RaincheckConnection",
                        "kind": "LinkedField",
                        "name": "rainchecks",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": "rainchecks(hasNonZeroBalance:false)"
                      },
                      (v4/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c8425bc88d390d884bac5bea239ecd8",
    "id": null,
    "metadata": {},
    "name": "RainchecksModalQuery",
    "operationKind": "query",
    "text": "query RainchecksModalQuery(\n  $redeemableAtFacilityId: ID\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Customer {\n          ...RainchecksList_customer_3JXKhy\n          rainchecks {\n            edges {\n              node {\n                id\n                squareGiftCard {\n                  id\n                  balance\n                }\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment Raincheck_raincheck on Raincheck {\n  id\n  expirationDate\n  facility {\n    id\n    name\n    raincheckConfiguration {\n      limitRedemptionToFacility\n    }\n  }\n  squareGiftCard {\n    id\n    balance\n    createdAt\n    squareId\n  }\n}\n\nfragment RainchecksList_customer_3JXKhy on Customer {\n  availableRainchecks: rainchecks(expired: false, giftCardIsActive: true, hasNonZeroBalance: true, redeemableAtFacilityId: $redeemableAtFacilityId) {\n    edges {\n      node {\n        ...Raincheck_raincheck\n        id\n        squareGiftCard {\n          id\n          balance\n          status\n        }\n      }\n    }\n  }\n  usedRainchecks: rainchecks(hasNonZeroBalance: false) {\n    edges {\n      node {\n        ...Raincheck_raincheck\n        id\n        squareGiftCard {\n          id\n          balance\n          status\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55a090d12049fe40ac6a6a9f17a7255f";

export default node;
